if (!customElements.get('picture-breakpoint')) {
  let sharedPictureObserver;

  function getSharedObserver() {
    if (!sharedPictureObserver) {
      sharedPictureObserver = new IntersectionObserver((entries, observer) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const element = entry.target;
          element.loadImage();
          observer.unobserve(element);
        }
      }, { rootMargin: '400px 0px' });
    }
    return sharedPictureObserver;
  }

  class PictureBreakpoint extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mounted === 'true') return;

      this.listenerController?.abort();
      this.listenerController = new AbortController();

      if ('IntersectionObserver' in window) {
        getSharedObserver().observe(this);
      } else {
        this.loadImage();
      }
    }

    disconnectedCallback() {
      if (sharedPictureObserver) sharedPictureObserver.unobserve(this);
      this.listenerController?.abort();
      this.listenerController = undefined;
      if (this.dataset.loading === 'true' && this.dataset.mounted !== 'true') {
        delete this.dataset.loading;
      }
    }

    loadImage() {
      if (this.dataset.mounted === 'true') return;
      if (this.dataset.loading === 'true') return;

      const img = this.querySelector('img');
      if (!img) return;
      if (!img.dataset.src && !img.getAttribute('src')) return;

      this.dataset.loading = 'true';

      const picture = img.closest('picture');
      const mobileSrcset = this.dataset.mobileSrcset;
      const mobileSizes = this.dataset.mobileSizes;
      const mobileMedia = this.dataset.mobileMedia;
      const tabletSrcset = this.dataset.tabletSrcset;
      const tabletSizes = this.dataset.tabletSizes;
      const tabletMedia = this.dataset.tabletMedia;

      if (picture && tabletSrcset && tabletMedia && !picture.querySelector('[data-picture-breakpoint-tablet]')) {
        const source = document.createElement('source');
        source.dataset.pictureBreakpointTablet = '';
        source.setAttribute('media', tabletMedia);
        if (tabletSizes) source.setAttribute('sizes', tabletSizes);
        source.setAttribute('srcset', tabletSrcset);
        picture.insertBefore(source, img);
      }

      if (picture && mobileSrcset && mobileMedia && !picture.querySelector('[data-picture-breakpoint-mobile]')) {
        const source = document.createElement('source');
        source.dataset.pictureBreakpointMobile = '';
        source.setAttribute('media', mobileMedia);
        if (mobileSizes) source.setAttribute('sizes', mobileSizes);
        source.setAttribute('srcset', mobileSrcset);
        picture.insertBefore(source, img);
      }

      const finish = () => {
        delete this.dataset.loading;
        this.dataset.mounted = 'true';
      };

      const signal = this.listenerController?.signal;
      img.addEventListener('load', finish, { once: true, signal });
      img.addEventListener('error', finish, { once: true, signal });

      const newSrcset = img.getAttribute('data-srcset');
      if (newSrcset) img.setAttribute('srcset', newSrcset);
      img.removeAttribute('data-srcset');

      const newSizes = img.getAttribute('data-sizes');
      if (newSizes) img.setAttribute('sizes', newSizes);
      img.removeAttribute('data-sizes');

      const newSrc = img.getAttribute('data-src');
      if (newSrc) img.setAttribute('src', newSrc);
      img.removeAttribute('data-src');

      if (img.complete) finish();
    }
  }

  customElements.define('picture-breakpoint', PictureBreakpoint);
}
